import {
	createProperty,
	deletePropertyImage,
	getAllCategories,
	getAllProperties,
	updateProperty,
	updatePropertyStatus,
	uploadPropertyImages,
	createCategory,
	updateCategory,
	getAllPropertyLite,
	getAllTags,
	createTag,
	updateTag,
	getAllSearchScore,
	updateSearchScore,
	getSingleProperty,
} from "../api";
import {
	PROPERTY_REDUCER_CREATE_NEW_CATEGORY,
	PROPERTY_REDUCER_CREATE_NEW_TAG,
	PROPERTY_REDUCER_CREATE_PROPERTY,
	PROPERTY_REDUCER_GET_ALL_CATEGORY,
	PROPERTY_REDUCER_GET_ALL_DISTRICT,
	PROPERTY_REDUCER_GET_ALL_PROPERTY,
	PROPERTY_REDUCER_GET_ALL_PROPERTY_LITE,
	PROPERTY_REDUCER_GET_ALL_PROPERTY_TYPE,
	PROPERTY_REDUCER_GET_ALL_TAG,
	PROPERTY_REDUCER_UPDATE_CATEGORY,
	PROPERTY_REDUCER_UPDATE_PROPERTY,
	PROPERTY_REDUCER_UPDATE_PROPERTY_STATUS,
	PROPERTY_REDUCER_UPDATE_TAG,
	PROPERTY_REDUCER_UPLOAD_IMAGES,
	PROPERTY_REDUCER_GET_ALL_SEARCH_INDEX,
	PROPERTY_REDUCER_UPDATE_SEARCH_INDEX,
	PROPERTY_REDUCER_GET_SINGLE_PROPERTY,
} from "../common/constants";
import ToastPopup from "../common/ToastPopup";
import { districtData } from "../data/districtData";
import { propertyTypeData } from "../data/propertyTypesData";

const getAllPropertyLiteData = async () => {
	const response = await getAllPropertyLite();
	if (response?.success) {
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const getAllPropertyType = () => {
	return propertyTypeData;
};

const getAllDistricts = () => {
	return districtData;
};

const getAllProperty = async () => {
	try {
		const propertyData = await getAllProperties();
		if (propertyData?.success) {
			return propertyData?.results ?? [];
		} else {
			ToastPopup(
				"error",
				propertyData?.message +
					(propertyData?.errors ? ". " + Object.values(propertyData?.errors) : "")
			);
			return null;
		}
	} catch (err) {
		console.log(err);
		ToastPopup("error", "Data request error: " + err);
		return null;
	}
};

const getAllCategory = async () => {
	const response = await getAllCategories();

	if (response?.success) {
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const createNewCategory = async (data) => {
	const response = await createCategory(data);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const updateCategoryData = async (id, data) => {
	const response = await updateCategory(id, data);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results;
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const getAllTagFromApi = async () => {
	const response = await getAllTags();

	if (response?.success) {
		return response?.results;
	} else {
		ToastPopup("error", response?.message);
		return null;
	}
};

const createNewTagInApi = async (data) => {
	const response = await createTag(data);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results;
	} else {
		ToastPopup("error", response?.message);
		return null;
	}
};

const updateTagInApi = async (id, data) => {
	const response = await updateTag(id, data);
	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results;
	} else {
		ToastPopup("error", response?.message);
		return null;
	}
};

const updateStatus = async (id, data) => {
	try {
		const property = await updatePropertyStatus(id, data);
		console.log(property);
		if (property?.success) {
			return property?.results;
		} else {
			ToastPopup(
				"error",
				property?.message + (property?.errors ? ". " + Object.values(property?.errors) : "")
			);
			return null;
		}
	} catch (err) {
		ToastPopup("error", "Data request error: " + err?.message);
		return null;
	}
};

const createNewProperty = async (data) => {
	try {
		const response = await createProperty(data);
		if (response?.success) {
			ToastPopup("success", response?.message);
			return response?.results;
		} else {
			ToastPopup(
				"error",
				response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
			);
			return null;
		}
	} catch (err) {
		ToastPopup("error", "Data request error: " + err);
		return null;
	}
};

const updatePropertyData = async (id, data) => {
	try {
		const response = await updateProperty(id, data);
		if (response?.success) {
			ToastPopup("success", response?.message);
			return response?.results;
		} else {
			ToastPopup(
				"error",
				response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
			);
			return null;
		}
	} catch (err) {
		ToastPopup("error", "Data request error: " + err);
		return null;
	}
};

const updateImages = async (id, data) => {
	try {
		let uploadResponse = null,
			deleteResponse = null;
		let message = "";

		console.log("fetch req: ", data);

		if (data?.imageData) {
			uploadResponse = await uploadPropertyImages(id, data.imageData);
			console.log("uploadImage: ", uploadResponse);
			message += uploadResponse?.message;
		}

		if (data?.deletedImageData) {
			deleteResponse = await deletePropertyImage(id, data.deletedImageData);
			console.log("deleteImage: ", deleteResponse);
			if (message.length > 0) message += " and ";
			message += deleteResponse?.message;
		}

		if (uploadResponse?.success || deleteResponse?.success) {
			ToastPopup("success", message);
			return uploadResponse?.success || deleteResponse?.success;
		} else {
			ToastPopup("error", message);
			return null;
		}
	} catch (err) {
		ToastPopup("error", "Data request error: " + err?.message);
		return null;
	}
};

const getSearchIndexFromApi = async () => {
	const response = await getAllSearchScore();

	if (response?.success) {
		return response?.results ?? {};
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const updateSearchIndexInApi = async (id, data) => {
	const response = await updateSearchScore(id, data);

	if (response?.success) {
		ToastPopup("success", response?.message);
		return response?.results ?? {};
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const getSinglePropertyFromApi = async (id) => {
	const response = await getSingleProperty(id);
	if (response?.success) {
		return response?.results ?? {};
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

//Reducers
export const PropertyReducer = (state, action) => {
	console.log("property-reducer-action-data: ", state, action);
	switch (action.type) {
		case PROPERTY_REDUCER_GET_ALL_PROPERTY:
			if (action.loading) {
				getAllProperty().then((res) =>
					action.dispatch({
						...action,
						loading: false,
						data: res,
					})
				);
				return state;
			} else {
				action?.loadingCb();
				if (action?.data) {
					action?.successCb();
					return action?.data;
				} else {
					action?.failedCb();
					return state;
				}
			}

		case PROPERTY_REDUCER_UPDATE_PROPERTY:
			if (action.loading) {
				updatePropertyData(action.data.id, action.data).then((res) =>
					action.dispatch({
						type: PROPERTY_REDUCER_UPDATE_PROPERTY,
						data: res,
						loading: false,
					})
				);
				return state;
			} else {
				return action.data
					? [...(state ?? [])?.filter((p) => p?.id !== action?.data?.id), action?.data]
					: state;
			}

		case PROPERTY_REDUCER_CREATE_PROPERTY:
			if (action.loading) {
				createNewProperty(action.data).then((res) =>
					action.dispatch({
						type: PROPERTY_REDUCER_CREATE_PROPERTY,
						data: res,
						loading: false,
					})
				);
				return state;
			} else {
				return action.data
					? [...(state ?? []).filter((p) => p?.id !== action?.data?.id), action?.data]
					: state;
			}

		case PROPERTY_REDUCER_UPDATE_PROPERTY_STATUS:
			if (action.loading) {
				updateStatus(action.data.id, {
					new_status: action.data.new_status,
				}).then((res) =>
					action.dispatch({
						type: PROPERTY_REDUCER_UPDATE_PROPERTY_STATUS,
						data: res,
						loading: false,
					})
				);
				return state;
			} else {
				return action.data
					? [...(state ?? [])?.filter((p) => p?.id !== action?.data?.id), action?.data]
					: state;
			}

		case PROPERTY_REDUCER_UPLOAD_IMAGES:
			if (action.loading) {
				updateImages(action.id, action.data).then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action?.loadingCb();
				if (action?.data) {
					action?.successCb();
				} else {
					action?.failedCb();
				}
				return state;
			}

		default:
			break;
	}
};

export const PropertyTypeReducer = (state, action) => {
	console.log("property-reducer-action-data: ", action);
	switch (action.type) {
		case PROPERTY_REDUCER_GET_ALL_PROPERTY_TYPE:
			return getAllPropertyType();
		default:
			break;
	}
};

export const DistrictsReducer = (state, action) => {
	console.log("property-reducer-action-data: ", action);
	switch (action.type) {
		case PROPERTY_REDUCER_GET_ALL_DISTRICT:
			return getAllDistricts();
		default:
			break;
	}
};

export const CategoryReducer = (state, action) => {
	console.log("property-reducer-action-data: ", action);
	switch (action.type) {
		case PROPERTY_REDUCER_GET_ALL_CATEGORY:
			if (action.loading) {
				getAllCategory().then((res) =>
					action.dispatch({
						...action,
						data: res,
						loading: false,
					})
				);
				return state;
			} else {
				action.callback();
				return action.data;
			}

		case PROPERTY_REDUCER_CREATE_NEW_CATEGORY:
			createNewCategory(action?.data).then((res) => action.callback());
			return state;
		case PROPERTY_REDUCER_UPDATE_CATEGORY:
			updateCategoryData(action?.id, action?.data).then((res) => action.callback());
			return state;

		default:
			break;
	}
};

export const TagReducer = (state, action) => {
	console.log("property-reducer-action-data: ", action);
	switch (action.type) {
		case PROPERTY_REDUCER_GET_ALL_TAG:
			if (action.loading) {
				getAllTagFromApi().then((res) =>
					action.dispatch({
						...action,
						data: res,
						loading: false,
					})
				);
				return state;
			} else {
				action.callback();
				return action.data;
			}

		case PROPERTY_REDUCER_CREATE_NEW_TAG:
			createNewTagInApi(action?.data).then((res) => action.callback());
			return state;
		case PROPERTY_REDUCER_UPDATE_TAG:
			updateTagInApi(action?.id, action?.data).then((res) => action.callback());
			return state;

		default:
			break;
	}
};

export const PropertyLiteReducer = (state, action) => {
	console.log("property-lite-reducer: ", action);
	switch (action.type) {
		case PROPERTY_REDUCER_GET_ALL_PROPERTY_LITE:
			if (action.loading) {
				getAllPropertyLiteData().then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action.callback();
				return action.data;
			}

		default:
			break;
	}
};

export const PropertySearchIndexReducer = (state, action) => {
	switch (action.type) {
		case PROPERTY_REDUCER_GET_ALL_SEARCH_INDEX:
			if (action.loading) {
				getSearchIndexFromApi().then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action.loadingCb();
				if (action.data) {
					action.successCb();
					return action.data;
				} else {
					action.failedCb();
					return state;
				}
			}
		case PROPERTY_REDUCER_UPDATE_SEARCH_INDEX:
			if (action.loading) {
				updateSearchIndexInApi(action.id, action.data).then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action.loadingCb();
				if (action.data) {
					action.successCb();
					return action.data;
				} else {
					action.failedCb();
					return state;
				}
			}
		default:
			break;
	}
};

export const SinglePropertyReducer = (state, action) => {
	switch (action.type) {
		case PROPERTY_REDUCER_GET_SINGLE_PROPERTY:
			if (action?.loading) {
				getSinglePropertyFromApi(action?.id).then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action.loadingCb();
				if (action?.data) {
					action.successCb();
					return action.data;
				} else {
					action.failedCb();
					return state;
				}
			}

		default:
			break;
	}
};
